import {merge} from 'merge-json'
import toml from '@iarna/toml'

export default async function mergeTOML(input1, input2) {
  const object1 = toml.parse(input1)
  const object2 = toml.parse(input2)

  const result = merge(object1, object2)
  return toml.stringify(result)
}